import { createUseStyles } from "react-jss";
import { mediaQueries } from "../../../../constants/mediaQueries";

export const RequestListItemStyle = createUseStyles((theme: any) => ({
    container: {
        display: "flex",

        width: "50%",
        [mediaQueries.TABLETPORTRAIT]: {
            width: "70%",
        },
        [mediaQueries.TABLET]: {
            width: "80%",
        },
        [mediaQueries.MOBILE]: {
            width: "100%",
        },
    },
    image: {
        width: "auto",
        maxWidth: "3rem",
    },
    text: {
        width: "90%",
        paddingRight: "var(--padding-sizes-sm)",
    },
    containerData: {
        display: "flex",
    },
    requestPreparedAssigned: {
        color: "var(--text-color-orange)",
    },
    requestPending: {
        color: "var(--text-color-red)",
    },
    requestAssigned: {
        color: "var(--text-color-blue)",
    },
    requestFinished: {
        color: "var(--text-color-green)",
    },
}));
